<template>
  <modal titulo="Odin - Processamento de Ato" id="odin-processamento-ato"
         :fechar="true" @close="close" :class="{'loading-ia': !!loadingTxt}" :loading="loading" :loading-txt="loadingTxt">

    <div class="alert alert-warning py-2 d-flex align-items-center" v-if="!loading && atoValidado">
      <div class="mr-auto">
        <i class="fa fa-lock mr-1"></i>
        Ato validado<span v-if="dataBus.ato.usuarioValidador"> por {{dataBus.ato.usuarioValidador.nome}}</span>. As sugestões da IA não podem ser aplicadas — remova a validação do ato para permitir a alteração.
      </div>
      <button type="button" class="btn btn-sm btn-outline-danger ml-2 text-nowrap"
              @click.prevent="removerValidacao()">
        <i class="fa fa-unlock mr-1"></i> Remover validação
      </button>
    </div>

    <div class="alert alert-warning py-2" v-if="!loading && !atoValidado && atoAssinado">
      <i class="fa fa-lock mr-1"></i>
      Ato assinado digitalmente<span v-if="dataBus.ato.usuarioAssinador"> por {{dataBus.ato.usuarioAssinador.nome}}</span>. As sugestões da IA não podem ser aplicadas — cancele a assinatura do ato para permitir a alteração.
    </div>

    <card titulo="Minuta do ato" v-if="!loading">
      <card-content>
        <div class="texto-minuta mb-2" v-html="dataBus.ato.texto" v-if="dataBus.ato.texto"></div>

        <div class="d-flex justify-content-between">
          <div class="text-muted small-2 mt-3">ID: {{dataBus.ato.id}}</div>

          <v-button class="btn btn-outline-primary mr-2" :run="editarMinuta" :popover="false">
            Editar Minuta
          </v-button>
        </div>
      </card-content>
    </card>

    <template v-if="!loading && dataBus.ia">

      <div class="row">
        <div class="col" v-if="dataBus.ia.situacaoJuridicaAnterior">

          <card titulo="Situação Jurídica Anterior">
            <card-content>
              <div class="texto-minuta mb-2" v-html="dataBus.ia.situacaoJuridicaAnterior.replaceAll('\n', '<br/>')"></div>
            </card-content>
          </card>

        </div>
        <div class="col" v-if="dataBus.ia.situacaoJuridica">

          <card titulo="Situação Jurídica Atualizada" classTitle="d-flex justify-content-between">
            <card-content>
              <div class="texto-minuta mb-2" v-html="dataBus.ia.situacaoJuridica.replaceAll('\n', '<br/>')"></div>
            </card-content>
          </card>

        </div>
      </div>


      <div class="alert-outline-warning alert my-3" v-if="revisarMinuta">
        <strong>ATENÇÃO:</strong> Ao realizar a leitura da minuta, a IA identificou que o texto pode estar apresentando algumas inconsistências. Favor revisar o texto antes de prosseguir.
      </div>


    </template>

    <card class="border-transparent" v-if="!loading && mostrar">

      <template #acoes>
        <ul class="nav nav-tabs">
          <li class="nav-item" v-for="menu in menus" :key="menu.id">
            <a class="nav-link" :class="{ active: activeTab === menu.id }"
               href="#" @click.prevent="activeTab = menu.id">
              {{menu.nome}}
            </a>
          </li>
        </ul>
      </template>

      <card-content id="conteudo-processamento">

        <div v-html="thinkText" v-if="activeTab == 'think'" class="mt-1 mb-4">
        </div>

        <card-table class="table-borderless table-striped mt-2" v-if="activeTab == 'geral'">
          <thead>
            <tr style="background: transparent" class="small">
              <th style="width:200px">Campo</th>
              <th style="width:400px">Atual</th>
              <th style="width:400px">Extraído</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dadosGerais" :key="index">
              <td>{{ item.campo }}</td>
              <td>{{ item.atual }}</td>
              <td>{{ item.extraido }}</td>
            </tr>
          </tbody>
        </card-table>

        <card-table class="table-borderless table-striped mt-2" v-if="activeTab == 'indicadorreal'">
          <thead>
            <tr style="background: transparent" class="small">
              <th style="width:200px">Campo</th>
<!--              <th style="width:400px">Atual</th>-->
              <th>Extraído</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dadosIndicadorReal" :key="index">
              <td>{{ item.campo }}</td>
<!--              <td>{{ item.atual }}</td>-->
              <td>{{ item.extraido }}</td>
            </tr>
          </tbody>
        </card-table>

        <div class="alert alert-outline-warning alert-sm mt-2 mb-3" v-if="activeTab == 'envolvidos'" >
          <p class="mb-2">
            <strong>Atenção: </strong> Apenas determinados papéis de envolvidos são extraídos pela IA para simplificar o processamento.
          </p>
        </div>

        <card-table class="table-borderless table-striped mt-2" v-if="activeTab == 'envolvidos'">
          <thead>
            <tr style="background: transparent" class="small">
              <th colspan=3 style="width:400px">Atual</th>
              <th style="width: 50px"></th>
              <th colspan=3 style="width:400px">Extraído</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in envolvidos">
              <tr class="small" :key="index">
                <td>
                  {{item.atual ? item.atual.nome || '-' : '-'}}
                  <span class="text-muted d-block" v-if="item.atual && item.atual.documento">{{item.atual.documento}}</span>
                </td>
                <td>{{item.atual ? item.atual.papel || '-' : '-'}}</td>
                <td>{{item.atual ? $formatters.currency(item.atual.fracao, {min : 2, max : 10}) || '-' : '-'}}</td>
                <td class="lborder">
                  <i v-if="!item.toggle" class="fa-solid fa-chevron-down pointer" @click.prevent="toggle('toggle', item, true)"></i>
                  <i v-if="item.toggle" class="fa-solid fa-chevron-up pointer" @click.prevent="toggle('toggle', item, false)"></i>
                </td>
                <td style="background-color: #1C1E24;"></td>
                <td>
                  {{item.extraido ? item.extraido.nome || '-' : '-'}}
                  <span class="text-muted d-block" v-if="item.extraido && item.extraido.documento">{{item.extraido.documento}}</span>
                </td>
                <td>{{item.extraido && item.extraido.papel ? item.extraido.papel.join(', ') || '-' : '-'}}</td>
                <td>{{item.extraido ? $formatters.currency(item.extraido.fracao, {min : 2, max : 10}) || '-' : '-'}} </td>
                <td class="lborder">
                  <i v-if="!item.toggle" class="fa-solid fa-chevron-down pointer" @click.prevent="toggle('toggle', item, true)"></i>
                  <i v-if="item.toggle" class="fa-solid fa-chevron-up pointer" @click.prevent="toggle('toggle', item, false)"></i>
                </td>
              </tr>
              <tr v-if="item.toggle" :key="index + '-toggle'" style="background: transparent">
                <td colspan="4" style="vertical-align: baseline; padding: 0;">
                  <DetalhesEnvolvido :condicao="item.atual" :item="item.atual" />
                </td>
                <td style="background-color: #1C1E24;"></td>
                <td colspan="4" style="vertical-align: baseline; padding: 0;">
                  <DetalhesEnvolvido :condicao="item.extraido" :item="item.extraido" />
                </td>
              </tr>

            </template>
          </tbody>
        </card-table>

      </card-content>

    </card>

    <template #footer>
      <div v-if="!loading" class="d-flex w-100 align-items-center">
        <button type="button" @click.prevent="close()" class="btn btn-outline-secondary">Cancelar</button>

        <v-button class="btn btn-outline-warning ml-2" :run="run" :popover="true">
          Processar Texto
        </v-button>

        <div class="ml-auto d-flex">
          <!-- Botão de comparação (somente para usuários VHL) -->
          <v-button
            class="btn btn-outline-info mr-2"
            :run="abrirComparacao"
            :popover="false"
            v-if="mostrar && $root.isVhlUser"
            title="Comparar dados extraídos com dados editados">
            <i class="fa-solid fa-code-compare mr-1"></i>
            Comparar Alterações
          </v-button>

          <v-button class="btn btn-outline-primary mr-2" :run="editarExtracao" :popover="false" v-if="mostrar">
            Editar Extração
          </v-button>

          <v-button class="btn btn-outline-success" :run="salvarAlteracoes" :popover="true" v-if="dataBus.ia && dataBus.ia.situacaoJuridica && !atoValidado && !atoAssinado">
            Salvar Sugestões
          </v-button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>

import AtoBusiness from "@/business/protocolo/AtoBusiness";
import Utils from "@/commons/Utils";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import CardTable from "@/components/Layout/components/CardTable.vue";
import Modal from "@/components/Modal.vue";
import FrontBusiness from "@/business/FrontBusiness";
import ModalOdinEditarProcessamentoAto from "@/views/Odin/modais/componentes/ModalOdinEditarProcessamentoAto.vue";
import ModalRemoverValidacaoAtos from "@/views/Odin/componentes/ModalRemoverValidacaoAtos.vue";
import OdinBusiness from "@/views/Odin/OdinBusiness";

import DetalhesEnvolvido from "@/views/Odin/componentes/DetalhesEnvolvido.vue";
import ModalOdinEditarMinuta from "@/views/Odin/modais/componentes/ModalOdinEditarMinuta.vue";
import ModalOdinComparacaoExtracao from "@/views/Odin/modais/componentes/ModalOdinComparacaoExtracao.vue";
import AtoLegadoBusiness from "@/business/indicadores/AtoLegadoBusiness";
import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";

export default {
  name: 'ModalOdinProcessamentoAto',
  components: {
    DetalhesEnvolvido,
    CardTable,
    Card, CardContent, Modal
  },
  props:{
    indicadorRealId: String,
    atoId: String,
  },

  modal: {
    width: 1200
  },

  async mounted() {
    this.load();
  },

  data(){
    return {
      activeTab: "geral",
      loading: true,
      loadingTxt: null,
      dadosGerais:[],
      dadosIndicadorReal:[],
      dataBus: {
        ato: null,
        ia: null
      },
    }
  },

  computed:{
    atoValidado() {
      return !!this.dataBus.ato?.validacao;
    },

    atoAssinado() {
      return !!this.dataBus.ato?.dataAssinatura;
    },

    thinkText(){
      let think = this.dataBus.ia?.think || '';
      think = think.replaceAll('\n', '<br/>');
      return think;
    },

    mostrar() {
      return this.dataBus.ia && this.dataBus.ia?.atoMatricula?.negocios?.length
    },

    revisarMinuta() {
      return this.dataBus.ia && this.dataBus.ia?.atoMatricula?.atoIncompleto
    },

    menus(){
      const menus = [{id: 'geral', nome: 'Dados Gerais'}];
      if(this.dadosIndicadorReal.length > 0){
        menus.push({id: 'indicadorreal', nome: 'Indicador Real'});
      }
      if(this.dataBus.ia?.envolvidos?.length > 0){
        menus.push({id: 'envolvidos', nome: 'Envolvidos do Ato'});
      }
      if(this.dataBus.ia?.think){
        menus.push({id: 'think', nome: 'Explicação da Análise'});
      }
      return menus;
    },
    envolvidos(){
      let lista = Utils.clone(this.dataBus.ato.envolvidos);
      let envolvidos = lista.map(r => ({
        nome: r.nome,
        atual: {
          id: r.id,
          indicadorPessoalId: r.indicadorPessoalId,
          nome: r.nome,
          fracao: r.fracao,
          papel: r.papel,
          documento: r.indicadorPessoalVersao?.indicadorPessoal?.documento,
          representanteNome: r.representantes?.[0]?.nome,
          representanteCpf: r.representantes?.[0]?.documento,
          genero: r.indicadorPessoalVersao?.sexo,
          nacionalidade: r.indicadorPessoalVersao?.nacionalidade,
          estadoCivil: r.indicadorPessoalVersao?.estadoCivil,
          profissao: r.indicadorPessoalVersao?.profissao,
          uniaoEstavel: r.indicadorPessoalVersao?.possuiUniaoEstavel,
          inscricaoEstadual: r.indicadorPessoalVersao?.inscricaoEstadual,
          rg: r.indicadorPessoalVersao?.rg,
          nomeConjuge: r.indicadorPessoalVersao?.conjuge?.nome,
          cpfConjuge: r.indicadorPessoalVersao?.conjuge?.documento,
          nomeExConjuge: r.indicadorPessoalVersao?.exConjuge?.nome,
          cpfExConjuge: r.indicadorPessoalVersao?.exConjuge?.documento,
          dataCasamento: r.indicadorPessoalVersao?.dataCasamento,
          casamentoAposLei6515: r.indicadorPessoalVersao?.casamentoAposLei6515,
          dataSeparacao: r.indicadorPessoalVersao?.dataSeparacao,
          dataExtincaoConjugal: r.indicadorPessoalVersao?.dataExtincaoConjugal,
          dataObito: r.indicadorPessoalVersao?.dataObito,
          certidaoObito: r.indicadorPessoalVersao?.certidaoObito,
          regimeBens: r.indicadorPessoalVersao?.regimeCasamento,
          email: r.indicadorPessoalVersao?.email,
          telefone: r.indicadorPessoalVersao?.telefone,
          cep: r.indicadorPessoalVersao?.cep,
          logradouro: r.indicadorPessoalVersao?.logradouro,
          numero: r.indicadorPessoalVersao?.numero,
          bairro: r.indicadorPessoalVersao?.bairro,
          cidade: r.indicadorPessoalVersao?.cidade,
          uf: r.indicadorPessoalVersao?.uf,
        }}));

      const extraidos = Utils.clone(this.dataBus.ia?.envolvidos || []);

      envolvidos.forEach(a => {

        for(let pos in extraidos) {

          //possui documento e sao iguais
          if(Utils.extrairNumeros(a.atual.documento) && Utils.extrairNumeros(a.atual.documento) == Utils.extrairNumeros(extraidos[pos].documento)
            && OdinBusiness.calcularSimilaridade(a.atual.nome, extraidos[pos].nome) >= 70){
            a.extraido = extraidos[pos];
            delete extraidos[pos];
            break;
          }

          // if(!Utils.extrairNumeros(a.atual.documento) && OdinBusiness.calcularSimilaridade(a.atual.nome, extraidos[pos].nome) >= 80){
          //   a.extraido = extraidos[pos];
          //   delete extraidos[pos];
          //   break;
          // }

        }

      })

      //após processar a lista, processa novamente com os que ficaram pra trás
      envolvidos.forEach(a => {
        if(!a.extraido){
          for (let pos in extraidos) {
            if(OdinBusiness.calcularSimilaridade(a.atual.nome, extraidos[pos].nome) >= 80){
              a.extraido = extraidos[pos];
              delete extraidos[pos];
              break;
            }
          }
        }
      });

      for(let pos in extraidos) {
        envolvidos.push({
          nome: extraidos[pos].nome,
          atual: null,
          extraido: extraidos[pos]
        })
      }

      envolvidos = Utils.orderBy(envolvidos, 'nome')

      return envolvidos;

    }
  },

  methods:{
    async close(retorno) {
      FrontBusiness.closeModal(retorno);
    },

    async editarMinuta() {
      let r = await FrontBusiness.openModal(ModalOdinEditarMinuta, {ato: this.dataBus.ato});
      if(r){
        if (r.xmlAssinado) {
          const result = await FrontBusiness.openConfirmacao(
            'Atenção! Você alterou um dos campos que compõem a assinatura do ato (Minuta). Ao continuar, o hash e o XML da assinatura serão removidos e será necessário realizar uma nova assinatura.',
            'Deseja continuar?'
          );
          if (result !== 'confirm') return;
          r.dto = r.dto || {};
          r.dto.removerAssinatura = true;
        }
        this.$set(this, 'loading', true);
        await AtoLegadoBusiness.save(r, r?.id).catch(this.showError);
        this.load();
      }
    },

    async abrirComparacao() {
      try {
        // Busca os dados originais e editados do banco de dados
        const comparacao = await OdinBusiness.compararExtracaoAto(this.atoId);

        if (!comparacao || !comparacao.dadosOriginais) {
          FrontBusiness.showError('', 'Não há dados de extração disponíveis para comparação');
          return;
        }

        await FrontBusiness.openModal(ModalOdinComparacaoExtracao, {
          dadosOriginais: comparacao.dadosOriginais,
          dadosEditados: comparacao.dadosEditados
        });
      } catch (error) {
        FrontBusiness.showError('', 'Erro ao buscar dados para comparação: ' + error.message);
      }
    },

    async editarExtracao(){
      let odin = Utils.clone(this.dataBus.ia);
      if (odin.indicadorReal) {
        for (const campo of ['areaPrivativa', 'areaComum', 'areaConstruida', 'areaAcrescida', 'areaReduzida', 'areaTotal', 'fracaoIdeal', 'cadastroImobiliario']) {
          const valor = odin.indicadorReal[campo];
          if (valor != null && valor !== '') {
            const normalizado = String(valor).replace(',', '.');
            const convertido = parseFloat(normalizado);
            if (!isNaN(convertido)) {
              odin.indicadorReal[campo] = convertido;
            }
          }
        }
        for (const campo of ['unidadeAutonoma', 'possuiGeorreferenciamento']) {
          const valor = odin.indicadorReal[campo];
          if (valor != null && valor !== '') {
              odin.indicadorReal[campo] = valor == '1';
          }
        }
        if (odin.indicadorReal.tipoImovel) {
          odin.indicadorReal.tipoImovel = (odin.indicadorReal.tipoImovel || '').toUpperCase();
        }
      }
      if (odin.atoMatricula.valorTransacao != null && odin.atoMatricula.valorTransacao !== '') {
        const normalizado = String(odin.atoMatricula.valorTransacao).replace(',', '.');
        const convertido = parseFloat(normalizado);
        if (!isNaN(convertido)) {
          odin.atoMatricula.valorTransacao = convertido;
        }
      }
      odin.atoMatricula.cancelamentoAto = (odin.atoMatricula.cancelamentoAto || [])?.join(', ');
      odin.atoMatricula.criacaoRestricoes = odin.atoMatricula.criacaoRestricoes || [];
      odin.atoMatricula.cancelamentoRestricoes = odin.atoMatricula.cancelamentoRestricoes || [];
      let r = await FrontBusiness.openModal(ModalOdinEditarProcessamentoAto, {odin});
      if(r){
        this.$set(this, 'loading', true);
        await OdinBusiness.editar(this.atoId, r).catch(r => {
          FrontBusiness.showError('', r.message);
          this.$set(this, 'loading', false);
        });
        this.load();
      }
    },

    // Remove a validação deste ato (confirmação expressa com motivo + auditoria) e recarrega a
    // tela — destravado, o ato volta a aceitar as sugestões da IA.
    async removerValidacao(){
      const ato = this.dataBus.ato;
      if(!ato?.id){
        return;
      }
      await FrontBusiness.openModal(ModalRemoverValidacaoAtos, {
        atos: [{id: ato.id, label: AtoBusiness.getCodigo(ato), descricao: ato.titulo}]
      });
      await this.load();
    },

    async load(){
      this.$set(this, 'loading', true);
      const ato = await AtoBusiness.getById(null, this.atoId);
      await FrontBusiness.sleep(200);
      const ia = await OdinBusiness.capturarExtracaoAto(this.atoId).catch(r => {
        return null;
      });
      const dadosGerais = [];
      // if(ia?.atoMatricula?.numeroAto) dadosGerais.push({id: 'numeroAto', campo: 'numeroAto', extraido: ia.atoMatricula.numeroAto, atual: ato?.numeroAto})
      // if(ia?.atoMatricula?.tipoAto) dadosGerais.push({id: 'tipoAto', campo: 'tipoAto', extraido: ia.atoMatricula.tipoAto, atual: ato?.tipoAto})
      if(ia?.atoMatricula?.dataAto) dadosGerais.push({id: 'dataAto', campo: 'Data do Ato', extraido: this.$formatters.date(ia.atoMatricula.dataAto), atual: this.$formatters.date(ato?.registro)})
      if(ia?.atoMatricula?.tituloAto) dadosGerais.push({id: 'tituloAto', campo: 'Título', extraido: ia.atoMatricula.tituloAto, atual: ato?.titulo})
      if(ia?.atoMatricula?.negocios) dadosGerais.push({id: 'negocios', campo: 'Negócio Jurídico', extraido: ia.atoMatricula.negocios?.join(', '), atual: null})
      if(ia?.atoMatricula?.valorTransacao) {
        const valorNormalizado = typeof ia.atoMatricula.valorTransacao === 'string'
          ? parseFloat(ia.atoMatricula.valorTransacao.replace(',', '.'))
          : ia.atoMatricula.valorTransacao;
        dadosGerais.push({id: 'valorTransacao', campo: 'Valor do Negócio/Alienação', extraido: this.$formatters.currency(valorNormalizado, 2, '-'), atual: null})
      }
      if(ia?.atoMatricula?.moedaTransacao) dadosGerais.push({id: 'moedaTransacao', campo: 'Moeda Utilizada', extraido: ia.atoMatricula.moedaTransacao, atual: null})
      if(ia?.atoMatricula?.dataTransacao) dadosGerais.push({id: 'dataTransacao', campo: 'Data da Alienação', extraido: this.$formatters.date(ia.atoMatricula.dataTransacao), atual: null})
      if(ia?.atoMatricula?.criacaoRestricoes) dadosGerais.push({id: 'criacaoRestricoes', campo: 'Criação de Restrição', extraido: ia.atoMatricula.criacaoRestricoes?.join(', '), atual: null})
      if(ia?.atoMatricula?.cancelamentoRestricoes) dadosGerais.push({id: 'cancelamentoRestricoes', campo: 'Cancelamento de Restrição', extraido: ia.atoMatricula.cancelamentoRestricoes?.join(', '), atual: null})
      if(ia?.atoMatricula?.cancelamentoAto) dadosGerais.push({id: 'cancelamentoAto', campo: 'Cancelamento de Ato', extraido: ia.atoMatricula.cancelamentoAto?.join(', '), atual: null})

      const dadosIndicadorReal = [];

// Dados básicos do imóvel
      if(ia?.indicadorReal?.tipoImovel) dadosIndicadorReal.push({id: 'tipoImovel', campo: 'Tipo de Imóvel', extraido: ia.indicadorReal.tipoImovel, atual: ato.ficha?.tipoImovel})
      if(ia?.indicadorReal?.numeroUnidade) dadosIndicadorReal.push({id: 'numeroUnidade', campo: 'Unidade', extraido: ia.indicadorReal.numeroUnidade, atual: ato.ficha?.unidade})

// Endereço
      if(ia?.indicadorReal?.tipoLogradouro) dadosIndicadorReal.push({id: 'tipoLogradouro', campo: 'Tipo de Logradouro', extraido: ia.indicadorReal.tipoLogradouro, atual: ato.ficha?.tipoLogradouro})
      if(ia?.indicadorReal?.nomeRua) dadosIndicadorReal.push({id: 'nomeRua', campo: 'Logradouro (rua)', extraido: ia.indicadorReal.nomeRua, atual: ato.ficha?.logradouro})
      if(ia?.indicadorReal?.numeroImovel) dadosIndicadorReal.push({id: 'numeroImovel', campo: 'Número', extraido: ia.indicadorReal.numeroImovel, atual: ato.ficha?.numero})
      if(ia?.indicadorReal?.complemento) dadosIndicadorReal.push({id: 'complemento', campo: 'Complemento', extraido: ia.indicadorReal.complemento, atual: ato.ficha?.complemento})
      if(ia?.indicadorReal?.bairro) dadosIndicadorReal.push({id: 'bairro', campo: 'Bairro', extraido: ia.indicadorReal.bairro, atual: ato.ficha?.bairro})
      if(ia?.indicadorReal?.cidade) dadosIndicadorReal.push({id: 'cidade', campo: 'Cidade', extraido: ia.indicadorReal.cidade, atual: ato.ficha?.cidade})
      if(ia?.indicadorReal?.estado) dadosIndicadorReal.push({id: 'estado', campo: 'Estado', extraido: ia.indicadorReal.estado, atual: ato.ficha?.estado})

// Condomínio/Loteamento
      if(ia?.indicadorReal?.condominio) dadosIndicadorReal.push({id: 'condominio', campo: 'Empreendimento', extraido: ia.indicadorReal.condominio, atual: ato.ficha?.empreendimento})
      if(ia?.indicadorReal?.bloco) dadosIndicadorReal.push({id: 'bloco', campo: 'Bloco', extraido: ia.indicadorReal.bloco, atual: ato.ficha?.bloco})
      if(ia?.indicadorReal?.loteamento) dadosIndicadorReal.push({id: 'loteamento', campo: 'Loteamento', extraido: ia.indicadorReal.loteamento, atual: ato.ficha?.empreendimento})
      if(ia?.indicadorReal?.lote) dadosIndicadorReal.push({id: 'lote', campo: 'Lote', extraido: ia.indicadorReal.lote, atual: ato.ficha?.lote})
      if(ia?.indicadorReal?.quadra) dadosIndicadorReal.push({id: 'quadra', campo: 'Quadra', extraido: ia.indicadorReal.quadra, atual: ato.ficha?.quadra})

      // Áreas
      if(ia?.indicadorReal?.fracaoIdeal) dadosIndicadorReal.push({id: 'fracaoIdeal', campo: 'Fração solo (%)', extraido: ia.indicadorReal.fracaoIdeal, atual: ato.ficha?.fracaoSoloPercentual})
      if(ia?.indicadorReal?.areaPrivativa) dadosIndicadorReal.push({id: 'areaPrivativa', campo: 'Área Privativa (m2)', extraido: ia.indicadorReal.areaPrivativa, atual: ato.ficha?.areaPrivativa})
      if(ia?.indicadorReal?.areaComum) dadosIndicadorReal.push({id: 'areaComum', campo: 'Área Comum (m2)', extraido: ia.indicadorReal.areaComum, atual: ato.ficha?.areaComum})
      // if(ia?.indicadorReal?.areaConstruida) dadosIndicadorReal.push({id: 'areaConstruida', campo: 'Área Construída (m2)', extraido: ia.indicadorReal.areaConstruida, atual: ato.ficha?.areaConstruida})

      // Alterações de área
      if(ia?.indicadorReal?.medidaArea) dadosIndicadorReal.push({id: 'medidaArea', campo: 'Unidade de Medida', extraido: ia.indicadorReal.medidaArea, atual: ato.ficha?.medidaArea})
      if(ia?.indicadorReal?.areaAcrescida) dadosIndicadorReal.push({id: 'areaAcrescida', campo: 'Área Acrescida', extraido: ia.indicadorReal.areaAcrescida, atual: ato.ficha?.areaAcrescida})
      if(ia?.indicadorReal?.areaReduzida) dadosIndicadorReal.push({id: 'areaReduzida', campo: 'Área Reduzida', extraido: ia.indicadorReal.areaReduzida, atual: ato.ficha?.areaReduzida})
      if(ia?.indicadorReal?.areaTotal) dadosIndicadorReal.push({id: 'areaTotal', campo: 'Área Total', extraido: ia.indicadorReal.areaTotal, atual: ato.ficha?.area})

      // Dados rurais e especiais
      if(ia?.indicadorReal?.denominacao) dadosIndicadorReal.push({id: 'denominacao', campo: 'Denominação', extraido: ia.indicadorReal.denominacao, atual: ato.ficha?.denominacao})
      if(ia?.indicadorReal?.zonaImovel) dadosIndicadorReal.push({id: 'zonaImovel', campo: 'Zona do Imóvel', extraido: ia.indicadorReal.zonaImovel, atual: null})
      if(ia?.indicadorReal?.unidadeAutonoma) dadosIndicadorReal.push({id: 'unidadeAutonoma', campo: 'Unidade Autônoma', extraido: ia.indicadorReal.unidadeAutonoma == 1 ? 'Sim' : 'Não', atual: null})

      // Cadastros rurais
      if(ia?.indicadorReal?.ccir) dadosIndicadorReal.push({id: 'ccir', campo: 'CCIR', extraido: ia.indicadorReal.ccir, atual: null})
      if(ia?.indicadorReal?.itrNirf) dadosIndicadorReal.push({id: 'itrNirf', campo: 'ITR/NIRF', extraido: ia.indicadorReal.itrNirf, atual: null})
      if(ia?.indicadorReal?.car) dadosIndicadorReal.push({id: 'car', campo: 'CAR', extraido: ia.indicadorReal.car, atual: null})
      if(ia?.indicadorReal?.cib) dadosIndicadorReal.push({id: 'cib', campo: 'CIB', extraido: ia.indicadorReal.cib, atual: null})
      if(ia?.indicadorReal?.cadastroImobiliario) dadosIndicadorReal.push({id: 'cadastroImobiliario', campo: 'Cadastro Imobiliário', extraido: ia.indicadorReal.cadastroImobiliario, atual: null})
      if(ia?.indicadorReal?.certificacaoIncra) dadosIndicadorReal.push({id: 'certificacaoIncra', campo: 'Certificação no SIGEF', extraido: ia.indicadorReal.certificacaoIncra, atual: null})

      // Georreferenciamento
      if(ia?.indicadorReal?.possuiGeorreferenciamento) dadosIndicadorReal.push({id: 'possuiGeorreferenciamento', campo: 'Possui Georreferenciamento', extraido: ia?.indicadorReal?.possuiGeorreferenciamento == 1? 'Sim' : 'Não', atual: null})
      if(ia?.indicadorReal?.georreferenciamento) dadosIndicadorReal.push({id: 'georreferenciamento', campo: 'Georreferenciamento', extraido: ia.indicadorReal.georreferenciamento, atual: null})

      // Registro e especificações
      if(ia?.indicadorReal?.registroAnterior) dadosIndicadorReal.push({id: 'registroAnterior', campo: 'Registro Anterior', extraido: ia.indicadorReal.registroAnterior, atual: null})
      if(ia?.indicadorReal?.confrontantes) dadosIndicadorReal.push({id: 'confrontantes', campo: 'Especificação e Confrontantes', extraido: ia.indicadorReal.confrontantes, atual: ato.ficha?.especificacao})

      if(ia?.indicadorReal?.status) {
        ia.indicadorReal.status = this.tratarStatus(ia?.indicadorReal?.status);
        dadosIndicadorReal.push({id: 'status', campo: 'Situação', extraido: this.nomearStatus(ia.indicadorReal.status), atual: this.nomearStatus(ato.ficha?.status)})
      }

      this.$set(this.dataBus, 'ato', ato);
      this.$set(this.dataBus, 'ia', ia);
      this.$set(this, 'dadosIndicadorReal', dadosIndicadorReal);
      this.$set(this, 'dadosGerais', dadosGerais);

      console.debug(this.dataBus.ia)
      this.$set(this, 'loading', false);
    },

    async run(){
      this.$set(this, 'loadingTxt', ' ');
      this.$set(this, 'loading', true);
      let cancelled = false;
      const msg = async () => {
        // const textos = [
        //   'Pensando...',
        //   'Analisando o negócio jurídico...',
        //   'Analisando as partes...'
        // ];
        const textos = [];
        for (const txt of textos) {
          if (cancelled) break;
          this.$set(this, 'loadingTxt', txt);
          await FrontBusiness.sleep(2500);
        }
      }

      const extracao = async () => {
        try {
          await OdinBusiness.realizarExtracaoAto(this.atoId, true);
        } catch (err) {
          cancelled = true;
          FrontBusiness.showError('', err.message);
          throw err;
        }
      };

      try {
        await Promise.all([ msg(), extracao() ]);
        await this.load();
      } catch (e) {
        console.error('err:', e);
      } finally {
        this.$set(this, 'loading', false);
        this.$set(this, 'loadingTxt', null);
      }
    },

    async salvarAlteracoes(){
      this.$set(this, 'loading', true);
      try {
        await OdinBusiness.salvarAlteracoes(this.atoId);
        this.close(true);
      } catch (r) {
        FrontBusiness.showError('', r.message);
      } finally {
        this.$set(this, 'loading', false);
      }
    },

    async salvar(){
    },

    nomearStatus(status = '') {
      return FrontBusiness.getLabel(status, IndicadorRealBusiness.getStatusImovel())
    },

    tratarStatus: OdinBusiness.tratarStatus,

    showError(e) {
      FrontBusiness.showError('', e.message);
    },
    toggle(key, item, valor){
      this.$set(item, key, valor);
      this.$forceUpdate();
    },
  }
}
</script>

<style lang="scss">
 .loading-ia {
   min-height: 200px;

   #overlay {
   }
   .spinner-border {
     display: inline-block;
     width: 3rem;
     height: 3rem;
     border-radius: 50%;
     border: 0.25em solid transparent;
     border-top-color: #007bff;
     border-right-color: transparent;
     background: conic-gradient(
         from 0deg,
         rgba(0, 123, 255, 0.2),
         rgba(0, 123, 255, 0.8),
         rgba(0, 123, 255, 0.2)
     );
     box-shadow:
       0 0 8px rgba(0, 123, 255, 0.6),
       0 0 16px rgba(0, 123, 255, 0.4);
     animation: spin-ia 1s linear infinite;
   }


   .loading-text {
     display: inline-block;
     font-family: 'Roboto', sans-serif;
     font-size: 1.25rem;
     font-weight: 500;
     letter-spacing: 1.5px;
     white-space: nowrap;
     animation: pulse-simple 1.5s ease-in-out infinite;
   }

   @keyframes pulse-simple {
     0%, 100% {
       opacity: 0.75;
     }
     50% {
       opacity: 1;
     }
   }

   @keyframes spin-ia {
     0% {
       transform: rotate(0deg) scale(0.9);
       opacity: 0.7;
     }
     50% {
       transform: rotate(180deg) scale(1.1);
       opacity: 1;
     }
     100% {
       transform: rotate(360deg) scale(0.9);
       opacity: 0.7;
     }
   }

 }
</style>
